import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { paintCodeOptions, finishOptions } from 'constants/finishing';

const Base = ({ control, tableView }) => {
    return (
        <>    
            {!tableView ? <Typography variant="h6" gutterBottom>Base</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.baseQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseType'
                type='text'
                control={control}
                label='Type'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.baseCoating'
                control={control}
                label='Coating'
                creatable={true}
                options={paintCodeOptions}
                style={{width: '39%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseSize'
                type='text'
                control={control}
                label='Size'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.baseEarthLug'
                type='text'
                control={control}
                label='Earth Lug'
                options={[
                    {
                        label: 'Yes',
                        id: 'Yes'
                    },
                    {
                        label: 'No',
                        id: 'No'
                    }
                ]}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.baseNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.baseFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default Base;
